<template><svg v-bind="$attrs"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 8">
  <circle cx="4" cy="4" r="4" fill="#7389A0"/>
</svg>
</template>